import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Form, Select, Tag } from 'tdesign-react';
import { connect } from 'react-redux';
import { useMemoizedFn } from 'ahooks';
import { find } from 'lodash';
import { fetchServiceList } from '@/slices/resourceSlice';
import { setCluster, setK8sClient, fetchClusterOptions } from '@/slices/execScriptSlice';
import { queryK8sList } from '@/services/execScriptService';
import { clusterTypeOptions } from '@/utils/constant';
import { toTsOptions } from '@/utils/common';
import OperateTitle from '../../components/OperateTitle';

const { FormItem } = Form;

function SelectCluster({
  envOptions,
  fetchServiceList,
  cluster,
  setK8sClient,
  fetchClusterOptions,
  clusterOptions,
  setCluster,
}) {
  const [form] = Form.useForm();

  // 环境下拉选项
  useEffect(() => {
    fetchServiceList();
  }, [fetchServiceList]);

  // 初始化集群选项
  const envChange = async (id) => {
    fetchClusterOptions(id);
    // 强行重置，（td不自动清除问题）
    form.reset({ fields: ['cluster'] });
  };

  // 查找k8s终端地址
  const findK8sClient = useMemoizedFn(async (clusterId) => {
    const { data } = await queryK8sList({
      opsClusterId: clusterId,
    });
    setK8sClient(data.items[0]);
  });

  const clusterChange = (clusterId) => {
    setCluster(clusterId);
  };

  useEffect(() => {
    if (cluster) {
      findK8sClient(cluster.id);
    }
  }, [cluster, findK8sClient]);

  return (
    <Root>
      <OperateTitle
        label='第一步：'
        title='选择目标集群'
        operator={
          cluster && <Tag>类型：{find(clusterTypeOptions, { value: cluster.type }).label}</Tag>
        }
      />
      <Form form={form} style={{ padding: '12px 0' }} layout='inline'>
        <FormItem label='选择环境'>
          <Select
            options={toTsOptions(envOptions)}
            onChange={envChange}
            popupProps={{ overlayInnerStyle: { width: 'auto' } }}
          />
        </FormItem>
        <FormItem name='cluster' label='选择集群'>
          <Select
            options={toTsOptions(clusterOptions)}
            value={cluster?.id}
            onChange={clusterChange}
            clearable
            popupProps={{ overlayInnerStyle: { width: 'auto' } }}
          />
        </FormItem>
      </Form>
    </Root>
  );
}

export default connect(
  (state) => ({
    envOptions: state.resource.serviceOptions,
    clusterOptions: state.execScript.clusterOptions,
    cluster: state.execScript.cluster,
  }),
  {
    fetchServiceList,
    setCluster,
    fetchClusterOptions,
    setK8sClient,
  },
)(SelectCluster);

const Root = styled.div`
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  margin-bottom: 16px;
`;
